import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SidebarService } from '../../services/sidebar.service';
import { CommonModule } from '@angular/common';
import { AppSidebarComponent } from '../app-sidebar/app-sidebar.component';
import { BackdropComponent } from '../backdrop/backdrop.component';
import { RouterModule } from '@angular/router';
import { AppHeaderComponent } from '../app-header/app-header.component';
import { DealFormDrawerComponent } from '../../../pages/deals/deal-form-drawer/deal-form-drawer.component';
import { LeadFormDrawerComponent } from '../../../pages/leads/lead-form-drawer/lead-form-drawer.component';
import { ContactoFormDrawerComponent } from '../../../pages/contactos/contacto-form-drawer/contacto-form-drawer.component';
import { EmpresaFormDrawerComponent } from '../../../pages/empresas/empresa-form-drawer/empresa-form-drawer.component';
import { CategoriaProductoFormDrawerComponent } from '../../../pages/productos/categoria-producto-form-drawer/categoria-producto-form-drawer.component';
import { ProductBundleFormDrawerComponent } from '../../../pages/productos/product-bundle-form-drawer/product-bundle-form-drawer.component';
import { DiscountRuleFormDrawerComponent } from '../../../pages/productos/discount-rule-form-drawer/discount-rule-form-drawer.component';
import { PriceListFormDrawerComponent } from '../../../pages/productos/price-list-form-drawer/price-list-form-drawer.component';
import { ProductoFormDrawerComponent } from '../../../pages/productos/producto-form-drawer/producto-form-drawer.component';
import { MeetingFormDrawerComponent } from '../../../pages/meeting/meeting-form-drawer/meeting-form-drawer.component';
import { CancellationReasonsFormDrawerComponent } from '../../../pages/meeting/config/cancellation-reasons/cancellation-reasons-form-drawer/cancellation-reasons-form-drawer.component';
import { HolidaysFormDrawerComponent } from '../../../pages/meeting/config/holidays/holidays-form-drawer/holidays-form-drawer.component';
import { MeetingTypesFormDrawerComponent } from '../../../pages/meeting/config/meeting-types/meeting-types-form-drawer/meeting-types-form-drawer.component';
import { MeetingStatusesFormDrawerComponent } from '../../../pages/meeting/config/meeting-statuses/meeting-statuses-form-drawer/meeting-statuses-form-drawer.component';
import { AvailabilityOverridesFormDrawerComponent } from '../../../pages/meeting/config/availability-overrides/availability-overrides-form-drawer/availability-overrides-form-drawer.component';
import { EmailTemplatesFormDrawerComponent } from '../../../pages/meeting/config/email-templates/email-templates-form-drawer/email-templates-form-drawer.component';
import { RoutingRulesFormDrawerComponent } from '../../../pages/meeting/config/routing-rules/routing-rules-form-drawer/routing-rules-form-drawer.component';
import { TaskFormDrawerComponent } from '../../../pages/tasks/task-form-drawer/task-form-drawer.component';
import { TaskTypesFormDrawerComponent } from '../../../pages/tasks/config/task-types/task-types-form-drawer/task-types-form-drawer.component';
import { TaskStatusesFormDrawerComponent } from '../../../pages/tasks/config/task-statuses/task-statuses-form-drawer/task-statuses-form-drawer.component';
import { TaskPrioritiesFormDrawerComponent } from '../../../pages/tasks/config/task-priorities/task-priorities-form-drawer/task-priorities-form-drawer.component';
import { TaskCategoriesFormDrawerComponent } from '../../../pages/tasks/config/task-categories/task-categories-form-drawer/task-categories-form-drawer.component';
import { TaskCancelReasonsFormDrawerComponent } from '../../../pages/tasks/config/task-cancel-reasons/task-cancel-reasons-form-drawer/task-cancel-reasons-form-drawer.component';
import { TemplateCategoryFormDrawerComponent } from '../../../pages/templates/template-category-form-drawer/template-category-form-drawer.component';
import { TicketsFormDrawerComponent } from '../../../pages/tickets/tickets-form-drawer/tickets-form-drawer.component';
import { TicketsPrioritiesFormDrawerComponent } from '../../../pages/tickets/config/priorities/priorities-form-drawer/priorities-form-drawer.component';
import { TicketsStatusesFormDrawerComponent } from '../../../pages/tickets/config/statuses/statuses-form-drawer/statuses-form-drawer.component';
import { TicketsCategoriesFormDrawerComponent } from '../../../pages/tickets/config/categories/categories-form-drawer/categories-form-drawer.component';
import { TicketsRootCausesFormDrawerComponent } from '../../../pages/tickets/config/root-causes/root-causes-form-drawer/root-causes-form-drawer.component';
import { TicketsCannedResponsesFormDrawerComponent } from '../../../pages/tickets/config/canned-responses/canned-responses-form-drawer/canned-responses-form-drawer.component';
import { TicketsPipelinesFormDrawerComponent } from '../../../pages/tickets/config/pipelines/pipelines-form-drawer/pipelines-form-drawer.component';
import { TicketsPipelineStagesFormDrawerComponent } from '../../../pages/tickets/config/pipelines/pipeline-stages-form-drawer/pipeline-stages-form-drawer.component';
import { TicketsTeamsFormDrawerComponent } from '../../../pages/tickets/config/teams/teams-form-drawer/teams-form-drawer.component';
import { ChatTeamsFormDrawerComponent } from '../../../pages/chatflows/chat-teams/chat-teams-form-drawer/chat-teams-form-drawer.component';
import { ChatTeamMemberFormDrawerComponent } from '../../../pages/chatflows/chat-teams/chat-team-member-form-drawer/chat-team-member-form-drawer.component';
import { TicketsTeamMembersFormDrawerComponent } from '../../../pages/tickets/config/teams/team-members-form-drawer/team-members-form-drawer.component';
import { TicketsSlaPoliciesFormDrawerComponent } from '../../../pages/tickets/config/sla-policies/sla-policies-form-drawer/sla-policies-form-drawer.component';
import { TicketsSlaTargetsFormDrawerComponent } from '../../../pages/tickets/config/sla-policies/sla-targets-form-drawer/sla-targets-form-drawer.component';
import { TicketsCustomFieldsFormDrawerComponent } from '../../../pages/tickets/config/custom-fields/custom-fields-form-drawer/custom-fields-form-drawer.component';
import { TicketsAssignmentRulesFormDrawerComponent } from '../../../pages/tickets/config/assignment-rules/assignment-rules-form-drawer/assignment-rules-form-drawer.component';
import { TicketsEscalationRulesFormDrawerComponent } from '../../../pages/tickets/config/escalation-rules/escalation-rules-form-drawer/escalation-rules-form-drawer.component';
import { QuoteApproverFormDrawerComponent } from '../../../pages/quotes/quote-approvers/quote-approver-form-drawer/quote-approver-form-drawer.component';
import { PhoneNumberFormDrawerComponent } from '../../../pages/call/phone-number-form-drawer/phone-number-form-drawer.component';
import { EmailChannelPolicyFormDrawerComponent } from '../../../pages/email-channel-policies/email-channel-policy-form-drawer/email-channel-policy-form-drawer.component';
import { RoleFormDrawerComponent } from '../../../pages/roles/role-form-drawer/role-form-drawer.component';
import { CallDialerWidgetComponent } from '../../../pages/call/call-dialer-widget/call-dialer-widget.component';
import { EmailComposeComponent } from '../../../pages/email-inbox/email-compose/email-compose.component';
import { WhatsappComposeComponent } from '../../../pages/whatsapp/whatsapp-compose/whatsapp-compose.component';
import { QuotesFormComponent } from '../../../pages/quotes/quotes-form/quotes-form.component';
import { QuoteDetailModalComponent } from '../../../pages/quotes/quote-detail-modal/quote-detail-modal.component';
import { QuoteFormModalService, QuoteFormModalState } from '../../../pages/quotes/services/quote-form-modal.service';
import { QuoteDetailModalService, QuoteDetailModalState } from '../../../pages/quotes/services/quote-detail-modal.service';
import { canUseCallDialer } from '../../../pages/call/call.constants';
import { AuthService } from '../../../pages/auth-pages/services/auth.service';
import { ConfirmDialogComponent } from '../../components/ui/confirm-dialog/confirm-dialog.component';
import { ToastContainerComponent } from '../../components/ui/alert/toast-container.component';
import { SegmentSetOpsModalComponent } from '../../../pages/segments/segment-set-ops-modal/segment-set-ops-modal.component';

@Component({
  selector: 'app-layout',
  imports: [
    CommonModule,
    RouterModule,
    AppHeaderComponent,
    AppSidebarComponent,
    BackdropComponent,
    DealFormDrawerComponent,
    LeadFormDrawerComponent,
    ContactoFormDrawerComponent,
    EmpresaFormDrawerComponent,
    CategoriaProductoFormDrawerComponent,
    ProductBundleFormDrawerComponent,
    DiscountRuleFormDrawerComponent,
    PriceListFormDrawerComponent,
    ProductoFormDrawerComponent,
    MeetingFormDrawerComponent,
    CancellationReasonsFormDrawerComponent,
    HolidaysFormDrawerComponent,
    MeetingTypesFormDrawerComponent,
    MeetingStatusesFormDrawerComponent,
    AvailabilityOverridesFormDrawerComponent,
    EmailTemplatesFormDrawerComponent,
    RoutingRulesFormDrawerComponent,
    TaskFormDrawerComponent,
    TaskTypesFormDrawerComponent,
    TaskStatusesFormDrawerComponent,
    TaskPrioritiesFormDrawerComponent,
    TaskCategoriesFormDrawerComponent,
    TaskCancelReasonsFormDrawerComponent,
    TemplateCategoryFormDrawerComponent,
    TicketsFormDrawerComponent,
    TicketsPrioritiesFormDrawerComponent,
    TicketsStatusesFormDrawerComponent,
    TicketsCategoriesFormDrawerComponent,
    TicketsRootCausesFormDrawerComponent,
    TicketsCannedResponsesFormDrawerComponent,
    TicketsPipelinesFormDrawerComponent,
    TicketsPipelineStagesFormDrawerComponent,
    TicketsTeamsFormDrawerComponent,
    ChatTeamsFormDrawerComponent,
    ChatTeamMemberFormDrawerComponent,
    TicketsTeamMembersFormDrawerComponent,
    TicketsSlaPoliciesFormDrawerComponent,
    TicketsSlaTargetsFormDrawerComponent,
    TicketsCustomFieldsFormDrawerComponent,
    TicketsAssignmentRulesFormDrawerComponent,
    TicketsEscalationRulesFormDrawerComponent,
    PhoneNumberFormDrawerComponent,
    QuoteApproverFormDrawerComponent,
    EmailChannelPolicyFormDrawerComponent,
    RoleFormDrawerComponent,
    CallDialerWidgetComponent,
    EmailComposeComponent,
    WhatsappComposeComponent,
    QuoteDetailModalComponent,
    QuotesFormComponent,
    ConfirmDialogComponent,
    ToastContainerComponent,
    SegmentSetOpsModalComponent,
  ],
  templateUrl: './app-layout.component.html',
})

export class AppLayoutComponent implements OnInit, OnDestroy {
  readonly isExpanded$;
  readonly isHovered$;
  readonly isMobileOpen$;
  readonly showCallDialer: boolean;

  // Estado del modal del wizard de cotización (global): se abre desde la lista de cotizaciones o
  // desde el detalle/kanban/lista de negocios vía QuoteFormModalService. Montado a nivel de layout
  // para que pueda abrirse encima de cualquier pantalla (incl. el detalle de negocio).
  quoteModalState: QuoteFormModalState = { open: false };

  // Estado del modal de DETALLE de cotización (incidente #27): el estándar del CRM presenta el
  // detalle en un modal. Montado a nivel de layout, ANTES del wizard, para que "Editar" desde el
  // detalle abra el wizard por encima.
  quoteDetailState: QuoteDetailModalState = { open: false };
  private readonly subs: Subscription[] = [];

  constructor(
    public sidebarService: SidebarService,
    authService: AuthService,
    private readonly quoteFormModal: QuoteFormModalService,
    private readonly quoteDetailModal: QuoteDetailModalService
  ) {
    this.isExpanded$ = this.sidebarService.isExpanded$;
    this.isHovered$ = this.sidebarService.isHovered$;
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;
    this.showCallDialer = canUseCallDialer(authService.getCurrentUser()?.roleName);
  }

  ngOnInit(): void {
    this.subs.push(this.quoteFormModal.state$.subscribe(state => this.quoteModalState = state));
    this.subs.push(this.quoteDetailModal.state$.subscribe(state => this.quoteDetailState = state));
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  // El wizard guardó (crear/actualizar): avisar a los suscriptores (lista de cotizaciones,
  // sección de cotizaciones del detalle de negocio) para que refresquen.
  onQuoteModalSaved(): void {
    this.quoteFormModal.notifySaved();
  }

  onQuoteModalClosed(): void {
    this.quoteFormModal.close();
  }

  onQuoteDetailClosed(): void {
    this.quoteDetailModal.close();
  }

  get containerClasses() {
    return [
      'flex-1',
      'transition-all',
      'duration-300',
      'ease-in-out',
      (this.isExpanded$ || this.isHovered$) ? 'xl:ml-[290px]' : 'xl:ml-[90px]',
      this.isMobileOpen$ ? 'ml-0' : ''
    ];
  }

}
